module.exports = __webpack_public_path__ + "static/img/a066.c493bf9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a066.jpg
// module id = YhIr
// module chunks = 0